import { AuthState } from './types';

export const initialState: AuthState = {
  accessToken: '',
  refreshToken: '',
};
